import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1006Status: 'idle',
    startProcess1006Error: undefined as any,
    loadUserParamsProcess1006Status: 'idle',
    loadUserParamsProcess1006Error: undefined as any,

    process1006List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1006 = createAsyncThunk('process1006Slice/startProcess1006', async ({ process1006 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1006/`,
        prepareData(process1006),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1006Status } = getState().process1006Slice
        return startProcess1006Status !== 'pending'
    }
})

export const loadUserParamsProcess1006 = createAsyncThunk('process1006Slice/loadUserParamsProcess1006', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1006/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1006Status } = getState().process1006Slice
        return loadUserParamsProcess1006Status !== 'pending'
    }
})

const Process1006Slice = createSlice({
    name: 'process1006Slice',
    initialState,
    reducers: {
        resetstartProcess1006: (state) => {
            state.job = undefined
            state.startProcess1006Error = undefined
        },
        resetstartProcess1006Error: (state) => {
            state.startProcess1006Error = undefined
        },
        resetloadUserParamsProcess1006: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1006Error = undefined
        },
        resetloadUserParamsProcess1006Error: (state) => {
            state.loadUserParamsProcess1006Error = undefined
        },
        removeFromProcess1006ListById: (state, action) => {
            state.process1006List = state.process1006List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1006ListByIds: (state, action) => {
            state.process1006List = state.process1006List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1006List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1006Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1006List = []
            state.startProcess1006Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1006.pending, (state) => {
            state.startProcess1006Status = 'pending'
            state.startProcess1006Error = undefined
        })
        builder.addCase(startProcess1006.fulfilled, (state, action) => {
            state.startProcess1006Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1006.rejected, (state, action) => {
            state.startProcess1006Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1006Error = action.error.message
            } else {
                state.startProcess1006Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1006.pending, (state) => {
            state.loadUserParamsProcess1006Status = 'pending'
            state.loadUserParamsProcess1006Error = undefined
        })
        builder.addCase(loadUserParamsProcess1006.fulfilled, (state, action) => {
            state.loadUserParamsProcess1006Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1006.rejected, (state, action) => {
            state.loadUserParamsProcess1006Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1006Error = action.error.message
            } else {
                state.loadUserParamsProcess1006Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1006,
    resetstartProcess1006Error,
    resetloadUserParamsProcess1006,
    resetloadUserParamsProcess1006Error,
    removeFromProcess1006ListById,
    removeFromProcess1006ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1006Slice.actions
export default Process1006Slice.reducer
